import ch122 from "../../../../assets/images/blogs/experimentalfeatures/122.png";
import Flask from "../../../../src/components/ExperimentalFeaturesList/Flask";
import * as React from 'react';
export default {
  ch122,
  Flask,
  React
};